module.exports = __webpack_public_path__ + "img/hardwood.2d6ef831.png";